import { render, staticRenderFns } from "./AllNotifications.vue?vue&type=template&id=32291968"
import script from "./AllNotifications.vue?vue&type=script&lang=js"
export * from "./AllNotifications.vue?vue&type=script&lang=js"
import style0 from "./AllNotifications.vue?vue&type=style&index=0&id=32291968&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports